import { IPropertiesOfPatchChangesForSubcategory } from 'types';

export const properties: IPropertiesOfPatchChangesForSubcategory[] = [
	{ id: 'activation', name: 'activation' },
	{ id: 'deactivation', name: 'deactivation' },
	{ id: 'availableForRepetition', name: 'availableForRepetition' },
	{ id: 'hideSubcategory', name: 'hideSubcategory' },
];
